/**
 * Sprint 3 Lot CONC-1-B FE — utility optimistic concurrency wrap axios.
 *
 * Pattern : utility function pure (arbitrage Q4 D2, pas hook React).
 * Toast 409 via alert() cohérent codebase (Lot 4 ter D1 β).
 * 1 clé i18n commune (Q2 B1 : common.conflictModified).
 *
 * Usage :
 *   const result = await optimisticSave(t, () =>
 *     axios.put(url, { ...body, updated_at: doc.updated_at })
 *   );
 *   if (!result.ok) {
 *     await refreshData();  // re-fetch doc pour récupérer updated_at à jour
 *     return;
 *   }
 *   // result.data = response.data
 *
 * Gère :
 * - 409 Conflict → alert(t('common.conflictModified')) + return {ok:false, conflict:true}
 * - autres erreurs → throw (caller catch normalement, comportement préservé)
 * - succès → return {ok:true, data}
 *
 * Pattern hérité de Sprint 4 BUG-07 fix 422 (catch ciblé + alert i18n) et
 * généralisé Sprint 3 C pour les 11 sites BE optimistic concurrency
 * (Sprint 3 A + B).
 */
// Toast Lot 3 — bridge module-level (calque apiInterceptor.js registerRateLimitHandler).
// optimisticSave est une utility PURE (hors React) : elle ne peut pas appeler
// useToast(). Le handler est enregistre par <ConflictToastBridge/> (toast central).
// optimisticSave pre-resout le message i18n (t deja dispo) et passe une STRING
// traduite au handler ; le bridge n'a donc pas besoin de t.
let _conflictHandler = null;

/**
 * Enregistre le handler appele sur conflit 409 (toast central).
 * Appele par <ConflictToastBridge/> avec un callback qui affiche un showError.
 */
export function registerConflictHandler(handler) {
  _conflictHandler = handler;
}

export async function optimisticSave(t, axiosCall) {
  try {
    const response = await axiosCall();
    return { ok: true, data: response.data };
  } catch (err) {
    if (err.response?.status === 409) {
      const message = t('common.conflictModified');
      if (_conflictHandler) {
        try {
          _conflictHandler(message);
        } catch (e) {
          // un handler defaillant ne casse pas le flux
        }
      } else {
        alert(message); // fallback secours si bridge non monte
      }
      return { ok: false, conflict: true };
    }
    throw err;
  }
}
